import moment from "moment";

export const InvoiceEngineDetailsHeaderConfig = [
  {
    label: "Plant",
    id: "organizationName",
  },

  {
    label: "Bill to Party Description", id: "oem",
    render: (data) => data?.oem?.name,
  },
  {
    label: "Invoice Number",
    id: "invoiceNumber",
  },
  {
    label: "Invoice Date",
    id: "invoiceDate",
    render: (data) => {
      return (
        <span>
          {data?.invoiceDate && moment(data.invoiceDate).format("DD/MM/YYYY")}
        </span>
      );
    },
  },
  {
    label: "List /Part Number", id: "listNo"
  },
  {
    label: "Engine Number",
    id: "engineSerialNumber",
  },
  {
    label: "Engine Model",
    id: "engineModel",
  },
  {
    label: "Created Date",
    id: "createdAt",
    render: (data) => {
      return (
        <span>
          {data?.createdAt && moment(data.createdAt).format("DD/MM/YYYY")}
        </span>
      );
    },
  },

];
